import { z } from 'zod'

export const CostFormulaZod = z.enum(['points', 'minutes'])
export type CostFormula = z.infer<typeof CostFormulaZod>

export const AutomatedAssignmentMinutesWeightsZod = z.strictObject({
  referenceWaitMinutes: z.number().finite().positive(),
  maximumPickupMinutes: z.number().finite().positive(),
  outsideServicePointOriginMinutes: z.number().finite().nonnegative(),
  outsideServicePointDestinationMinutes: z.number().finite().nonnegative(),
  idleTimeBonusMaxMinutes: z.number().finite().nonnegative(),
  idleTimeBonusMinutesPerIdleMinute: z.number().finite().nonnegative(),
  firstAssignmentBonusMinutes: z.number().finite().nonnegative(),
  staleGpsMinutes: z.number().finite().nonnegative(),
  noPreciseGpsInLocationMinutes: z.number().finite().nonnegative(),
  noPreciseGpsInRegionMinutes: z.number().finite().nonnegative(),
  noPreciseGpsInInstitutionMinutes: z.number().finite().nonnegative(),
  estimatedAvailabilityWithoutGeolocationMinutes: z.number().finite().nonnegative(),
  manualTransmissionNotRequiredMinutes: z.number().finite().nonnegative(),
})
export type AutomatedAssignmentMinutesWeights = z.infer<typeof AutomatedAssignmentMinutesWeightsZod>

export const ConfigurationAutomatedAssignmentMinutesZod = AutomatedAssignmentMinutesWeightsZod.extend({
  regionOverrides: z.record(z.string(), AutomatedAssignmentMinutesWeightsZod.partial().strict()).default({}),
})
